export enum ProgressBarCalcMethodEnum {
  Percentage,
  XOfY
}
